'use strict';

/* $ */
/* global _ */
/* global Backbone */
/* global Marionette */

import { CountInput, SelectInput, ValueInput } from '../../common/count_input';

/**
 * Класс модели параметра калькулятора
 *     Поля модели зависят от вида калькулятора
 */
class CalculatorParamModel extends Backbone.Model {
    default(){
        return {
            min: 0,
            max: 0,
            step: 0,
        };
    }
    initialize(){
        let self = this;

        /** свойство value_invisible показывает выводить параметр на картинке калькулятора или нет
         * здесь приводим значение свойства к булеву.
         */
        if(self.get('value_invisible') == 0){
            self.set('value_invisible', false, { silent: true });
        }

        if(self.get('value_invisible') == 1){
            self.set('value_invisible', true, { silent: true });
        }
    }
}

/**
 * Класс коллекции моделей параметров калькулятора
 * Коллекция реагирует на изменение в любой модели из коллекции.
 */
class CalculatorParamModelCollection extends Backbone.Collection {
    model() {
        return CalculatorParamModel;
    }
    // Функция получения хеша параметров из коллекции.
    getParams(){
        let self = this;
        let pairs = {};

        self.each(function(model){
            let type = model.get('type');
            switch(type){
            case 'text':
                pairs[ model.get('name') ] = model.get('value');
                break;
            default:
                pairs[ model.get('name') ] = parseFloat(model.get('value'));
            }
        });

        return pairs;
    }
}

/**
 * Представление параметра калькулятора
 *     Возможны 3 типа представления:
 *         select - выбор из списка
 *         only_value - блокированный input с одним значением
 *         number - число (может быть дробным или целым. От этого меняется тип ввода)
 */
class CalculatorParam extends Marionette.View {
    getTemplate() {
        return '#tpl-calculator__param';
    }
    className(){
        return 'calculator-param';
    }
    ui() {
        return {
            'input': '.js-calculator__param-input'
        };
    }
    onRender() {
        let self = this;

        let input = self.getUI('input');
        let show_type = self.model.get('show_type');
        switch(show_type){
        case 'select':
            self.input_value = new SelectInput({ el: input,
                                                 model: self.model,
                                                 field: 'value',
                                                 type: self.model.get('type'),
                                                 values: self.model.get('values') });
            break;
        case 'only_value':
            self.input_value = new ValueInput({ el: input,
                                                model: self.model,
                                                field: 'value' });
            break;
        default:
            self.input_value = new CountInput({ el: input,
                                                model: self.model,
                                                field: 'value',
                                                type: self.model.get('type'),
                                                show_type: self.model.get('show_type'),
                                                min: parseFloat(self.model.get('min')),
                                                max: parseFloat(self.model.get('max')),
                                                step: parseInt(self.model.get('step'), 10) });
        }
        if(self.input_value){
            self.input_value.render();
        }
    }
    templateContext(){
        let self = this;
        let name = self.model.get('publ_name');
        let unit = self.model.get('unit');
        if(unit){
            name+= ', '+unit;
        }
        return {
            publ_name: name
        };
    }
}

/**
 * Коллекция представлений. Генерирует все представления параметров калькулятора по коллекции моделей.
 * Ловит изменения в коллекции моделей.
 */
class CalculatorParamCollection extends Marionette.CollectionView {
    childView() {
        return CalculatorParam;
    }
    collectionEvents() {
        return {
            'change': 'onCollectionChange'
        };
    }
    className(){
        return 'calculator__params';
    }
    // Сообщим о том, что коллекция изменилась
    onCollectionChange() {
        let self = this;
        self.triggerMethod('collection:changed');
    }
}

/**
 * Представление параметра калькулятора на картинке
 */
class CalculatorImageParam extends Marionette.View {
    getTemplate() {
        return '#tpl-calculator__param-image';
    }
    className(){
        return 'calculator-param-image';
    }
    modelEvents(){
        return {
            'change:value': 'render'
        };
    }
    initialize(){
        let self = this;

        if(self.model.get('value_invisible')){
            self.$el.hide();
        }else{
            let css = {};
            _.each(['top', 'left', 'right'], function(rule){
                let value = self.model.get(rule) || undefined;

                if(!_.isUndefined(value)){
                    css[rule] = value;
                }
            });

            if(!_.isEmpty(css)){
                self.$el.css(css);
            }
        }

    }
}

/**
 * Коллекция представлений параметров на изображении
 */
class CalculatorImageParamCollection extends Marionette.CollectionView {
    childView() {
        return CalculatorImageParam;
    }
    className(){
        return 'calculator__image';
    }
    onRender(){
        let self = this;
        let src = self.model.get('image');
        if(src){
            let img = new Image();
            img.onload = function(){
                self.$el.prepend(this);
            };
            img.src = src;
        }
    }
}

export {
    CalculatorParamModel,
    CalculatorParamModelCollection,
    CalculatorParam,
    CalculatorParamCollection,
    CalculatorImageParam,
    CalculatorImageParamCollection
};

